import React from "react";
import TakeOffDatasourceCard, { type TakeOffCardModel } from "../shared/TakeOffDatasourceCard";
import { useAto } from "./AtoContext";
import { getAtoPackageUrl } from "../../../../integrations/qto/sources/ato/api";
import { openExternalUrl } from "../../../../utils/links";

const useAtoCardModel = (): TakeOffCardModel => {
  const {
    atoProject,
    atoPackage,
    atoAggregatedQtos,
    atoTakeoffItemCount,
    atoLastUpdated,
    refreshTakeoffs,
    disconnectAtoToSelector,
  } = useAto();

  return {
    present: !!atoPackage,
    title: atoPackage?.name || atoPackage?.id || "",
    secondary: atoProject?.name,
    aggregatedQtos: atoAggregatedQtos,
    takeoffItemCount: atoTakeoffItemCount,
    lastUpdated: atoLastUpdated,
    emptyTooltip: "This package has no takeoff lines to review",
    onLaunch: atoProject ? () => openExternalUrl(getAtoPackageUrl(atoProject.id)) : undefined,
    onRefresh: () => void refreshTakeoffs(),
    onDisconnect: disconnectAtoToSelector,
  };
};

const AtoDatasourceCard = ({ onCardClick }: { onCardClick: () => void }) => {
  const model = useAtoCardModel();
  return <TakeOffDatasourceCard sourceId="ato" model={model} onCardClick={onCardClick} />;
};

export default AtoDatasourceCard;
